<template>
    <v-row class="justify-content-md-center">
        <div style="display: flex;align-items: center;flex-direction: row;" align="center" justify="center">
            <v-col>
                <div>
                    <button class="btn-outline-none" type="button" @click="start" v-bind:disabled="isRecording" title="Start Recroding">
                        <i class="fas fa-microphone" style="font-size: 24px;"></i>
                    </button>
                </div>
                <div>Record</div>
            </v-col>
            <v-col style="min-width: 75px;" class="pause-resume">
                <div>
                    <svg v-if="isRecording && isPaused" style="cursor: pointer;" @click="pause" enable-background="new 0 0 511.448 511.448" height="24" viewBox="0 0 511.448 511.448" width="24" xmlns="http://www.w3.org/2000/svg"><path fill="rgba(0, 0, 0, 0.54)" d="m436.507 74.94c-99.913-99.913-261.64-99.927-361.567 0-99.913 99.913-99.928 261.64 0 361.567 99.913 99.913 261.639 99.928 361.567 0 99.914-99.911 99.93-261.639 0-361.567zm-180.783 394.451c-117.816 0-213.667-95.851-213.667-213.666s95.851-213.667 213.667-213.667 213.667 95.851 213.667 213.667-95.851 213.666-213.667 213.666z" /><path fill="rgba(0, 0, 0, 0.54)" d="m247.283 239.148-96-74.667c-13.775-10.714-33.893-.864-33.893 16.577v149.333c0 17.563 20.25 27.186 33.893 16.577l96-74.667c10.795-8.397 10.81-24.746 0-33.153zm-87.893 48.305v-63.458l40.795 31.729z" /><path fill="rgba(0, 0, 0, 0.54)" d="m309.057 160.058c-11.598 0-21 9.402-21 21v149.333c0 11.598 9.402 21 21 21s21-9.402 21-21v-149.333c0-11.598-9.402-21-21-21z" /><path fill="rgba(0, 0, 0, 0.54)" d="m383.724 160.058c-11.598 0-21 9.402-21 21v149.333c0 11.598 9.402 21 21 21s21-9.402 21-21v-149.333c0-11.598-9.402-21-21-21z" /></svg>
                    <button class="btn-outline-none" type="button" v-else v-bind:class="{'text-danger': isRecording && !isPaused }" @click="pause" v-bind:disabled="!isRecording">
                        <i class="far fa-pause-circle" style="font-size: 24px;"></i>
                    </button>
                </div>
                <div v-bind:class="{'text-danger': isRecording && !isPaused }">{{pauseText}}</div>
            </v-col>
            <v-col>
                <div>
                    <button type="button" class="btn-outline-none" @click="stop" v-bind:disabled="!isRecording">
                        <i class="far fa-stop-circle" style="font-size: 24px;"></i>
                    </button>
                </div>
                <div>Stop</div>
            </v-col>
        </div>
        <v-col cols="12">
            <div align="center" class="duration">{{recordedTime}}</div>
        </v-col>
        <v-col cols="12" v-if="micFailedText">
            <div align="center" error>{{micFailedText}}</div>
        </v-col>
    </v-row>
</template>

<script>
    import { Recorder } from '@/libs/xstek-recorder';
    import Encoder from '@/libs/encoder'
    import { setInterval, clearInterval } from 'timers';
    import jQuery from 'jquery';
    let $ = jQuery;
    // const URL = window.URL || window.webkitURL;
    export default {
        props: {
            afterXstekRecording: { type: Function },
            micXstekFailed: { type: Function },
        },
        data() {
            return {
                recorder: null,
                stream: null,
                pauseText: 'Pause',
                isRecording: false,
                isPaused: true,
                isStoped: true,
                interval: null,
                seconds: 0,
                micFailedText: null,
            }
        },
        computed: {
            recordedTime() {
                if (this.recorder) {
                    return new Date(this.seconds * 1000).toISOString().substr(14, 5);
                }
                else {
                    return '00:00';
                }
            }
        },
        methods: {
            start() {
                this.seconds = 0;
                const constraints = {
                    video: false,
                    audio: {
                        channelCount: 1,
                        echoCancellation: false
                    }
                };
                var AudioContext = window.AudioContext || window.webkitAudioContext;
                var audioContext = new AudioContext;
                navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
                    /* assign to stream for later use */
                    this.stream = stream;
                    /* use the stream */
                    var input = audioContext.createMediaStreamSource(stream);
                    ///* Create the Recorder object and configure to record mono sound (1 channel) Recording 2 channels will double the file size */
                    this.recorder = new Recorder(input, {
                        numChannels: 1
                    }, Encoder);
                    this.recorder.record();
                    this.startTimer();
                    this.isRecording = true;
                    this.isPaused = false;
                    this.isStoped = false;
                    $('.pause-resume').prop('title', 'Pause Recording');
                }).catch(function(err) {
                    this.micFailedText = `Mic failed ${err.name}: ${err.message}`;
                    if (this.micXstekFailed)
                        this.micXstekFailed(err);
                });
            },
            pause() {
                if (this.recorder.recording) {
                    // pause
                    this.isPaused = true;
                    this.recorder.stop();
                    this.stopTimer();
                    this.pauseText = "Resume";
                    $('.pause-resume').prop('title', 'Resume Recording');
                } else {
                    // resume
                    this.isPaused = false;
                    this.recorder.record();
                    this.startTimer();
                    this.pauseText = "Pause";
                    $('.pause-resume').removeClass('error--text');
                    $('.pause-resume').prop('title', 'Pause Recording');
                }
            },
            stop() {
                this.pauseText = "Pause";
                this.stopTimer();
                try {
                    this.recorder.stop();
                    $('.pause-resume').prop('title', '');
                    this.stream.getAudioTracks().forEach((audioTrack) => { audioTrack.stop() });
                    this.isRecording = false;
                    this.isPaused = true;
                    this.isStoped = true;
                    var record = this.recorder.lameEncoder.finish();
                    if (this.afterXstekRecording) {
                        this.afterXstekRecording({ blob: record.blob, url: record.url, duration: this.recordedTime });
                    }
                }
                finally {
                    this.recorder = null;
                }

            },
            startTimer() {
                this.interval = setInterval(() => {
                    ++this.seconds;
                }, 1000);
            },
            stopTimer() {
                clearInterval(this.interval);
            }
        },
        async created() {

        }
    }
</script>
<style>
    .duration {
        font-family: 'Roboto', sans-serif;
        color: #AEAEAE;
        font-size: 32px;
        font-weight: 500;
        margin-bottom: 16px;
        padding-left: 15px;
        padding-right: 15px;
    }
</style>